import Link16 from '@carbon/icons-react/es/link/16';
import React, { FC } from 'react';
import { CopyToClipboard } from './copy-to-clipboard';

interface Props {
  popoverText?: string;
}

export const CopyUrlToClipboard: FC<Props> = ({ popoverText }) => (
  <CopyToClipboard
    popoverText={popoverText}
    textToCopy={window.location.href}
    icon={<Link16 />}
  />
);
